import { useStore } from 'effector-react'

import {
  $sectionList,
  $totalSectionList,
  getSectionList,
  sectionListMounted,
} from './model'
import { SectionListRequest } from './types'

export const useSectionList = () => {
  const onChangeSectionList = ({
    limit,
    page,
    orderBy,
    orderDirection,
  }: SectionListRequest) => {
    sectionListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
    })
  }
  const loading = useStore(getSectionList.pending)

  const sectionList = useStore($sectionList)
  const totalSectionList = useStore($totalSectionList)

  return {
    sectionList,
    totalSectionList,
    loading,
    onChangeSectionList,
  }
}
